import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Theme } from '@mui/material'
import { useMediaQuery } from '@mui/system'
import { TailwindScope } from './components/TailwindScope'
import { useGoogleOneTapLogin } from '@react-oauth/google'
import LandingPage from './LandingPage'
import { getUrl, getUtmValues } from '../../util/helperFunctions'
import { notificationFail } from '../../store/actions'
import { NOTIFICATIONS } from '../../util/notification'
import { oneTaplogin } from '../../store/actions/auth'
import { PROMPT_PARENT_ID } from '../../services/googleOneTapLogin/config'
import { page_viewed } from '../../services/mixpanel'

export default function MinimalLayout() {
  const dispatch = useDispatch()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      dispatch(oneTaplogin(credentialResponse) as any)
    },
    onError: () => {
      dispatch(notificationFail(NOTIFICATIONS.ERROR.someThingWrong) as any)
    },
    auto_select: false,
    cancel_on_tap_outside: true,
    prompt_parent_id: isMobile ? undefined : PROMPT_PARENT_ID // Conditionally set prompt_parent_id
  })

  useEffect(() => {
    // adding this for Google Analytics
    // document.title = 'DOT Ads - Bitcoin and Crypto Ad Network'
    const url = getUrl()
    const { utm_source, utm_medium, utm_campaign } = getUtmValues(url)
    const data = {
      url,
      page_name: 'landing',
      utm_source,
      utm_medium,
      utm_campaign
    }
    page_viewed(data)
    return () => {
      document.title = 'DOT Ads Dashboard'
    }
  }, [])

  return (
    <TailwindScope>
      <LandingPage />
    </TailwindScope>
  )
}
